import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Infringement} from '../../intefaces/infringement.interface';
import {InfringementService} from '../../services/infringement.service';
import {StatusMessageService} from '../../services/status-message.service';

@Component({
  selector: 'app-infringement-details',
  standalone: false,

  templateUrl: './infringement-details.component.html',
  styleUrl: './infringement-details.component.scss'
})
export class InfringementDetailsComponent {
  identifier!: string;
  infringement!: Infringement;
  isLoading: boolean = true;

  constructor(private route: ActivatedRoute, private infringementService: InfringementService, private statusMessage: StatusMessageService) {
  }

  ngOnInit(): void {
    this.identifier = String(this.route.snapshot.paramMap.get('identifier'));
    this.infringementService.getInfringement(this.identifier)
      .subscribe({
        next: (data) => {
          this.infringement = data
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          this.statusMessage.showStatusMessage("Data could not be loaded!", "error");
        }
      });
  }

  refreshDataMethod() {
    this.isLoading = true;
    this.infringementService.getInfringement(this.identifier)
      .subscribe({
        next: (data) => {
          this.infringement = data
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          this.statusMessage.showStatusMessage("Data could not be loaded!", "error");
        }
      });
  }

  //testdata
  private loadInfringement(identifier: string): Infringement {
    return {
      "attachments": ["Gabba"],
      "identifier": "2024.226 U",
      "contractValue": 150654,
      "accused": {
        "name": "RIVERIT",
        "url": "https://riverit.net/company/partners/?sphrase_id=755",
        "email": "info@riverit.net",
        "country": "Ukraine",
        "countryCode": "UA",
        "address": "Shota Rustaveli St. 10, Kyiv"
      },
      "debitor": {
        "ID": "301589",
        "invoiceAmmount": 25
      },
      "infringementType": 1,
      "infringementStatus": 0,
      "infringementDetails": "No copyright info",
      "genericComments": [
        {
          "date": "2024-12-23",
          "comment": "Allet supi hier."
        }
      ],
      "responsibleEmployee": "Philipp.Ehinger@TecAlliance.net",
      "lastUpdatedBy": "Philipp.Ehinger@TecAlliance.net",
      "externalLawyer": null,
      "itSecurityCheck": {
        "checked": true,
        "itSecurityComments": [
          {
            "date": "2024-12-23",
            "comment": "Des sönd de Verbrecha!"
          }
        ],
        "orderID": ["8463846", "4123413"]
      },
      "dateCreated": "2024-12-23",
      "dateClosed": "2024-12-28",
      "warningSent": "2024-12-24",
      "reminderDate": "2024-12-25",
      "secondReminderDate": "2024-12-27",
      "warningDeadline": "2025-01-07",
      "reminderDeadline": "2025-01-08",
      "secondReminderDeadline": "2025-01-10"
    }
  }
}
